import SubscriptionPlans from "@/pages/AgencyProtral/Auth/Signup/components/SubscriptionPlans"

const AgencySubscriptionPlansCom = ({ showSubscriptionDialog, setShowSubscriptionDialog, handlePlanSelect,agencyProfileData }: any) => {
    
    return (
        <div>
            <SubscriptionPlans
                open={showSubscriptionDialog}
                onClose={() => setShowSubscriptionDialog(false)}
                onPlanSelect={handlePlanSelect}
                noOfProviders={agencyProfileData?.noOfProvider}
                agency={true}
                noOfUser={agencyProfileData?.noOfUser}
                 
            />
        </div>
    )
}
export default AgencySubscriptionPlansCom